import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "header-content__inner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-content__txt" }, "道路データビューア")
], -1)
const _hoisted_2 = [
  _hoisted_1
]

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'header-content',
  props: {
    modifires: { type: [String, Array, Boolean] }
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(_unref(mapModifires)('header-content', _ctx.modifires))
  }, _hoisted_2, 2))
}
}

})